// extracted by mini-css-extract-plugin
export default {"shadowBlock":"ShadowControl_shadowBlock__GYonQ"};